export class TransSource {
  public Key: string;
  public tableName: string;
  public column: string;

  constructor(Key: string, tableName: string, column: string) {
    this.Key = Key;
    this.tableName = tableName;
    this.column = column;
  }
}
